/**
 * Client-side request ID utilities for correlating requests
 */
import * as Sentry from '@sentry/react';

export const generateRequestId = (): string => {
  return `req_${Date.now()}_${crypto.randomUUID().slice(0, 8)}`;
};

export const attachRequestId = (requestId: string): void => {
  Sentry.getCurrentScope()?.setTag('request_id', requestId);
};

export const getRequestIdHeader = (requestId: string): Record<string, string> => {
  return {
    'X-Request-ID': requestId };
};
